/**
 * The pieces of a push payload both tap consumers read.
 *
 * `user_notifications` composes two paths server-side and ships them in `data`:
 * `landing_url`, where the tap navigates, and `engagement_url`, where the tap is
 * reported (`build_data` in user_notifications/notifications/push.py). Both arrive
 * relative and with the `/api` prefix stripped, because that is the prefix every
 * caller on this side already adds.
 *
 * Server-composed or not, a path off the payload is validated before it is used: FCM
 * data is the one place where a destination reaches the client without passing through
 * our own code first.
 */

/** An in-app path: exactly one leading slash, and no scheme-ish escape. */
export const isInAppPath = (value: unknown): value is string =>
    typeof value === 'string' &&
    value.startsWith('/') &&
    // '//host/x' is protocol-relative and would leave the app. '/\host/x' is the
    // same attack through a separator some parsers fold to '/', so both are out.
    !value.startsWith('//') &&
    !value.startsWith('/\\');
